import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MonoCondition = styled.span`
  display: inline-block;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.chip};
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
`

export const EmptyStateWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 4rem 2rem;
  border: 1px dashed ${tokens.border.strong};
  border-radius: ${tokens.radius.card};
`
